import React, { createContext, useContext } from 'react';

// Create the context
const APIDetailsContext = createContext();

// Context provider component
export const APIDetailsContextProvider = ({ children, belongsTo, apiInfo, cartDetails, orderDetails, apiDetailsOnClickHandlers }) => {
    return (
        <APIDetailsContext.Provider value={{ belongsTo, apiInfo, cartDetails, orderDetails, apiDetailsOnClickHandlers }}>
            {children}
        </APIDetailsContext.Provider>
    );
};

// Custom hook to use context in components
export const useAPIDetailsContext = () => useContext(APIDetailsContext);
